import TrackerGrid from "@/components/TrackerGrid";

const COLS = [
  { key: "ref_code", label: "Ref Code", type: "text", width: 160 },
  { key: "trip_type", label: "Trip Type", type: "select",
    options: ["Round Trip", "One Way"] },
  { key: "dep_pickup", label: "Dep Pick-up", type: "text" },
  { key: "dep_drop", label: "Dep Drop", type: "text" },
  { key: "dep_date", label: "Dep Date", type: "text", width: 100 },
  { key: "dep_time", label: "Dep Time", type: "text", width: 80 },
  { key: "dep_location", label: "Dep Location", type: "text" },
  { key: "ret_pickup", label: "Ret Pick-up", type: "text" },
  { key: "ret_drop", label: "Ret Drop", type: "text" },
  { key: "ret_date", label: "Ret Date", type: "text", width: 100 },
  { key: "ret_time", label: "Ret Time", type: "text", width: 80 },
  { key: "ret_location", label: "Ret Location", type: "text" },
  { key: "passengers", label: "Passengers", type: "text", width: 80 },
  { key: "vehicle_type", label: "Vehicle Type", type: "text" },
  { key: "department", label: "Department", type: "text" },
  { key: "payment_mode", label: "Payment Mode", type: "text" },
  { key: "status", label: "Status", type: "select",
    options: ["In Progress", "Approved", "Completed", "Rejected", "On Hold"] },
  { key: "current_stage", label: "Current Stage", type: "text" },
  { key: "applicant_name", label: "Applicant", type: "text" },
  { key: "submitted_at", label: "Submitted At", type: "text", width: 160 },
];

export default function TransportTrackerPage() {
  return (
    <TrackerGrid
      endpoint="/analytics/transport-tracker"
      exportPath="/analytics/transport-tracker/export.xlsx"
      heading="Transportation Bookings Tracker"
      columns={COLS}
      dateRangeKey="submitted_at"
    />
  );
}
